module.exports = __webpack_public_path__ + "static/img/zd.8a700954.png";